import { createUseStyles } from 'react-jss';

export const useReviewsSectionStyles = createUseStyles({
  bgImageStyles: {
    backgroundImage: 'url(' + '/images/face-review.png' + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    height: '400px',
    width: '90%',
    marginBottom: '-20px',
    zIndex: '2',
    '@media (min-width: 768px)': {
      width: '630px',
    },
  },
});
